import withLayout from '../../hocs/Layout'
import {CodRemittance} from './CodRemittance'
import WalletHistory from './WalletHistory'

function CodRemittancePage() {
  return (
    <div id='main-content' className='container-fluid'>
      <CodRemittance />
    </div>
  )
}

function WalletRechargesPage() {
  return (
    <div id='main-content' className='container-fluid'>
      <WalletHistory />
    </div>
  )
}

function PassbookPage() {
  return (
    <div id='main-content' className='container-fluid'>
      <WalletHistory isPassbook />
    </div>
  )
}

export const BillingCodRemittance = withLayout(CodRemittancePage)
export const BillingWalletRecharges = withLayout(WalletRechargesPage)
export const BillingPassbook = withLayout(PassbookPage)

export default BillingCodRemittance
